module.exports = __webpack_public_path__ + "assets/img/cjzq.3cd6bdb4.png";